import { isLocalOrPreviewEnv } from '@bts-web/utils-functions';
import { PROD_CONFIGS } from './PROD_CONFIGS';
import { STAGING_CONFIGS } from './STAGING_CONFIGS';

export const APPLICATION_CONFIGS = isLocalOrPreviewEnv()
  ? STAGING_CONFIGS
  : PROD_CONFIGS;
